class FAQAccordion extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const detailsElements = this.querySelectorAll("details");

    detailsElements.forEach((details) => {
      const summary = details.querySelector("summary");

      if (summary) {
        summary.addEventListener("click", (e) => {
          e.preventDefault();

          if (details.hasAttribute("open")) {
            details.removeAttribute("open");
          } else {
            // Close all other details elements in this accordion
            detailsElements.forEach((otherDetails) => {
              if (otherDetails !== details) {
                otherDetails.removeAttribute("open");
              }
            });

            details.setAttribute("open", "");
          }
        });
      }
    });
  }
}

customElements.define("faq-accordion", FAQAccordion);
